import { clsx } from 'clsx';
import { FunctionComponent } from 'react';
import { NodeLogo } from '../NodeLogo/NodeLogo';
import { Tooltip } from '../../../tooltip/Tooltip';
import { ENTITY_TYPE_DATA_IDS_CONTRACT } from './entityTypeDataIdContract';

interface EntityTypeProps {
  logo: string;
  logoDarkMode: string;
  logoSize?: number;
  title: string;
  className?: string;
  titleClassName?: string;
  Extra?: FunctionComponent;
  extraProps?: object;
}

export function EntityType({
  logo,
  logoSize = 1,
  logoDarkMode,
  title,
  className,
  titleClassName,
  Extra,
  extraProps = {}
}: EntityTypeProps) {
  return (
    <div
      className={clsx('center-flex-row w-100', className)}
      data-id={ENTITY_TYPE_DATA_IDS_CONTRACT.base}
    >
      <NodeLogo
        dataId={ENTITY_TYPE_DATA_IDS_CONTRACT.logo}
        logoURL={logo}
        darkModeLogoURL={logoDarkMode}
        size={logoSize}
      />

      <Tooltip
        dataId={ENTITY_TYPE_DATA_IDS_CONTRACT.tooltip_title}
        title={title}
        enableOnTextOverflow
      >
        <span
          data-id={ENTITY_TYPE_DATA_IDS_CONTRACT.title}
          className={clsx('ml-1 text-ellipsis', titleClassName)}
        >
          {title}
        </span>
      </Tooltip>

      {Extra ? <Extra {...extraProps} /> : null}
    </div>
  );
}
